import { render, staticRenderFns } from "./saticiaktarim.vue?vue&type=template&id=1baa709c"
import script from "./saticiaktarim.vue?vue&type=script&lang=js"
export * from "./saticiaktarim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports